(ns common.transaction-process.prefill
  "Declarative create-form prefill for TP sub-entity slots. A slot may carry a
   `:slot/prefill` map of {entity-attr default-value}; a value may be a sentinel
   keyword resolved at form-open time against an injected runtime context. This
   keeps templates pure data (serializable/diffable, like the rest of the DSL)
   while the resolver stays pure and testable — the only impure bit (reading the
   clock) happens at the call edge and is passed in.

   Sentinels:
   - :tp.prefill/today — the current local calendar day at UTC midnight (epoch
     ms). The caller supplies it as `:today-utc-midnight-ms` in the context.
     Note this is a calendar day, NOT a precise instant (`now`); the two are
     deliberately distinct.")

(def today-sentinel :tp.prefill/today)

(defn resolve-value
  "Expand a single prefill value against `ctx`. Non-sentinel values pass through."
  [v {:keys [today-utc-midnight-ms]}]
  (if (= v today-sentinel) today-utc-midnight-ms v))

(defn resolve-prefill
  "Expand a slot's `:slot/prefill` map into concrete create-form defaults using
   the runtime `ctx` (e.g. `{:today-utc-midnight-ms <epoch-ms>}`). nil prefill -> {}."
  [prefill ctx]
  (reduce-kv (fn [m k v] (assoc m k (resolve-value v ctx)))
             {}
             (or prefill {})))
